import { render } from "./InputItemForm.vue?vue&type=template&id=4493e824"
import script from "./InputItemForm.vue?vue&type=script&lang=js"
export * from "./InputItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__